import { toast } from "sonner";
import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";
import { Badge } from "@/components/ui/badge";

export default function AdminSupportPage() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    api.adminSupportList().then((r) => setItems(r.data || [])).catch(() => toast.error("Couldn't load support tickets")).finally(() => setLoading(false));
  }, []);
  return (
    <div className="space-y-6">
      <h1 className="font-heading text-3xl font-semibold">Support notes</h1>
      {loading ? (
        <Skeleton className="h-40 w-full" />
      ) : items.length === 0 ? (
        <Card className="p-10 text-center text-muted-foreground" data-testid="admin-support-empty">
          No support notes yet.
        </Card>
      ) : (
        <Card className="p-5 space-y-3">
          {items.map((n) => (
            <div key={n.id} className="py-3 border-b last:border-0 border-border" data-testid="admin-support-note">
              <div className="flex items-center justify-between">
                <span className="text-xs text-muted-foreground">Vendor {n.vendor_id} • {n.created_at ? new Date(n.created_at).toLocaleString() : ""}</span>
                <Badge variant="outline" className="capitalize">{n.status}</Badge>
              </div>
              <p className="mt-1 text-sm whitespace-pre-wrap">{n.note}</p>
            </div>
          ))}
        </Card>
      )}
    </div>
  );
}
